import { render } from "./Multiselect.vue?vue&type=template&id=2045eaee"
import script from "./Multiselect.vue?vue&type=script&lang=js"
export * from "./Multiselect.vue?vue&type=script&lang=js"
script.render = render

export default script